import _ from 'lodash';
import { getAllInfo, reportBaseData } from '../../utility/kdReport/baseData';
import { kdDeviceInfo, kdEnvInfo } from './reportBase';
import { isomorphicConfig } from '../../utility/';
import { post } from '../../fetchers/fetch';
const host = _.get(isomorphicConfig, 'kdStatHost');

/**
 * 第0项是需要哪些字段 需要自己传吧
 * 第1项是r5中需要哪些字段
 */
const infoMap = {
  pageExp: [
    ['fromuin', 'touin', 'r4', 'kandian_mode_new'],
    ['algorithm_id', 'qimei', 'rowkey'],
  ], // r3 单独添加
  arcitleDuration: [
    ['fromuin', 'touin'],
    ['os', 'rowkey'],
  ], // r5.article_duration 单独添加
  articleRate: [
    ['fromuin', 'touin'],
    ['os', 'rowkey'],
  ], // touin r5.article_area 单独添加
  authoreClick: [
    ['touin', 'r4'],
    ['algorithm_id', 'network_type', 'rowkey', 'os', 'version', 'imsi', 'idfa', 'imei', 'is_intensify'],
  ], // r3 单独添加
  followClick: [
    ['fromuin', 'kandian_mode_new', 'touin', 'r4'],
    ['algorithm_id', 'network_type', 'os', 'version', 'imsi', 'idfa', 'imei', 'is_intensify', 'rowkey'],
  ], // 关注按钮点击 r3 is_done 单独添加
  followBtnShow: [
    ['touin', 'fromuin', 'scene_type', 'qimei', 'algorithm_id', 'kandian_mode_new', 'rowkey', 'puin'],
    ['rowkey'],
  ],
  followBtnClick: [
    ['touin', 'fromuin', 'scene_type', 'qimei', 'algorithm_id', 'kandian_mode_new', 'rowkey', 'puin'],
    ['rowkey'],
  ],
  praiseClick: [['touin'], ['rowkey', 'op_cnt']],
  shareClick: [['touin'], ['rowkey', 'op_cnt']],
  commentClick: [['touin'], ['rowkey', 'op_cnt']],
  commentInput: [
    ['puin', 'kandian_mode_new'],
    ['os', 'op_cnt'],
  ],
  videoShareExp: [[], ['rowkey']],
  videoShareClick: [[], ['rowkey']],
  videoSharePlay: [[], ['rowkey']],
  feedbackClick: [
    ['fromuin', 'touin'],
    ['channel_id', 'feeds_type', 'rowkey', 'op_cnt'],
  ],
  feedbackRpt: [
    ['fromuin', 'touin'],
    ['feeds_type', 'channel_id', 'op_cnt'],
  ],
};
const mainActionMap = {
  pageExp: '0X8008989',
  arcitleDuration: '0X8009781',
  articleRate: '0X8009782',
  authoreClick: '0X800898A',
  followClick: '0X800898B',
  followBtnShow: '0X800B1A6',
  followBtnClick: '0X800B1A7',
  praiseClick: '0X8009764',
  shareClick: '0X800AD76',
  commentClick: '0X8009749',
  commentInput: '0X800844A',
  videoShareExp: '0X800BEF0',
  videoShareClick: '0X800BEF1',
  videoSharePlay: '0X800BEF2',
  feedbackClick: '0X8007058',
  feedbackRpt: '0X8009990',
};

const initPostData = async (articleData, user) => {
  const [baseData, device, allInfo, env] = await Promise.all([
    reportBaseData(articleData),
    kdDeviceInfo(),
    getAllInfo(articleData),
    kdEnvInfo(),
  ]);
  const postData = {
    device,
    env,
    user: {
      appid_info: {
        appid: user.appid,
        openid: user.uin,
        token: user.token,
        qbid: user.qbid,
      },
    },
  };
  return { baseData, postData, allInfo };
};

class KdBigTReport {
  allInfo = {};
  baseData = {};
  postData = {};

  constructor(baseData, postData, allInfo) {
    this.url = `${host}/ReportT`;
    this.baseData = baseData;
    this.postData = postData;
    this.allInfo = allInfo;
  }

  static async build(articleData, user) {
    const { baseData, postData, allInfo } = await initPostData(articleData, user);
    return new KdBigTReport(baseData, postData, allInfo);
  }

  formatInfo(data) {
    // 把基础数据和每个上报需要的独立数据拼接在一起
    const reportKeys = [
      'Pb_account_lifeservice', // mainAction
      data.kd_id,
      data.touin, // toUin。 发文的用户的puin
      data.subAction, // subAction
      data.actionName, // actionName
      0, // fromType
      1, // count_unknown
      0, // result,
      data.r2, // r2
      data.r3, // r3
      data.r4, // r4
      JSON.stringify(data.r5), // r5
    ];
    const info = reportKeys.join('|');
    return info;
  }

  report(type, params = {}) {
    // r5Keys: 固定的r5字段
    const [baseKeys = [], r5Keys = []] = infoMap[type];
    const reportData = {};
    reportData.subAction = mainActionMap[type];
    reportData.actionName = mainActionMap[type];
    reportData.kd_id = this.allInfo.kd_id;
    reportData.r5 = Object.assign({}, this.baseData);
    const time = parseInt(new Date().getTime() / 1000, 10);
    reportData.r5.upload_time = time;
    const paramsR5 = params.r5 || {}; // 定制化的r5字段
    baseKeys.forEach((item) => (reportData[item] = this.allInfo[item]));
    if ((r5Keys && r5Keys.length) || paramsR5) {
      r5Keys.forEach((item) => (reportData.r5[item] = this.allInfo[item]));
      Object.keys(paramsR5).forEach((key) => (reportData.r5[key] = paramsR5[key]));
    }
    Object.keys(params).forEach((key) => {
      if (key !== 'r5') reportData[key] = params[key];
    });
    return this.sendReport(reportData, time);
  }

  sendReport(data, time) {
    const info = this.formatInfo(data);
    this.postData.msg_report_info = [{ time, info }];
    return post(this.url, {
      body: JSON.stringify(this.postData),
      conType: 'application/json; charset=utf-8',
    });
  }
}

export default KdBigTReport;
